import { defineMessages } from '../translate';

/** Split from `team` so the always-loaded entry chunk carries only these strings. */
export default defineMessages('team-tabs', {
  tabYourTasks: 'Your tasks',
  tabOverview: 'Overview',
  tabProjects: 'Projects',
  tabMembers: 'Members',
  tabSettings: 'Settings',
} as const);
